import { Box, Container, Paper, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { nextViewConnectBusinessState } from "../redux/features/connectBusinessStateSlice";
import ButtonConnectBusinessServices from "./buttonConnectBusinessServices";
import { connectBusinessFlowSx } from "./connectBusinessFlowStyles";

export const ConnectBusinessTypeOfJob = () => {
  const dispatch = useDispatch();

  const handleSubmit = (e) => {
    if (e) e.preventDefault();
    dispatch(nextViewConnectBusinessState());
  };

  return (
    <Container
      maxWidth="md"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        py: { xs: 4, md: 6 },
      }}
    >
      <Paper
        component="form"
        onSubmit={handleSubmit}
        elevation={0}
        role="form"
        aria-labelledby="title-job-type"
        sx={{
          width: "100%",
          ...connectBusinessFlowSx.panel,
          maxWidth: 740,
          maxHeight: 400,
          borderRadius: 5,
          //background: "red",
          overflow: "hidden",
          border: "none",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            px: { xs: 3, md: 4 },
            py: { xs: 3, md: 4 },
          }}
        >
          <Typography
            id="title-job-type"
            variant="h4"
            fontWeight={800}
            sx={{
              textAlign: "center",
              ...connectBusinessFlowSx.title,
            }}
          >
            Let's find the right cleaner for you
          </Typography>

          <Typography
            variant="body1"
            sx={{
              mt: 1.5,
              textAlign: "center",
              ...connectBusinessFlowSx.copy,
              maxWidth: 680,
              mx: "auto",
            }}
          >
            Select the service type to connect with a cleaner that fits with your needs
          </Typography>
        </Box>

        {/* Content */}
        <Box
          sx={{
            px: { xs: 2.5, md: 4 },
            py: { xs: 3, md: 4 },
            backgroundColor: "transparent",
            display: "flex",
            flexDirection: "column",
            gap: 2.5,
            alignItems: "stretch",
          }}
        >
          {/* Mantiene tu componente y su prop sin cambios */}
          <ButtonConnectBusinessServices updateComponentState={nextViewConnectBusinessState} />
        </Box>

        {/* Footer (opcional, conserva submit por teclado/enter) */}
        <Box
          sx={{
            px: { xs: 2.5, md: 4 },
            py: 2.5,
            display: "flex",
            justifyContent: "center",
          }}
        >
          {/* Mantiene submit accesible con Enter, aunque el botón interno haga dispatch */}
          <Box
            component="button"
            type="submit"
            aria-label="Continue"
            // Botón invisible para no duplicar CTA visual pero conservar submit del form.
            sx={{
              position: "absolute",
              width: 1,
              height: 1,
              opacity: 0,
              pointerEvents: "none",
            }}
          />
        </Box>
      </Paper>
    </Container>
  );
};

export default ConnectBusinessTypeOfJob;
